import React,
{
  memo,
  useMemo,
  useContext,
} from 'react';
import {
  Authenticator,
  useAuthenticator,
  TextField,
  PasswordField,
  PhoneNumberField,
  View,
  Button,
} from '@aws-amplify/ui-react';
import { v4 as uuidv4 } from 'uuid';
import { Drawer } from 'antd';
import '@aws-amplify/ui-react/styles.css';

import './styles.scss';
import UserContext from '../../contexts/UserContext';
import { CloseIcon } from '../icons';

const AuthDrawer = () => {
  const { authDrawerOpen, setAuthDrawerOpen } = useContext(UserContext);

  const legalPPAcknowlegement = (
    <p>
      By signing up and logging into Seagull, you acknowledge that you have read,
      understand, and agree to GLOS&apos;
      <a href="https://glos.org/legal/">
        {' '}
        Legal Disclaimers
      </a>
      {' '}
      and
      <a href="https://glos.org/privacy-policy/">
        {' '}
        Privacy Policy
      </a>
      .
    </p>
  );

  const components = useMemo(() => ({
    SignIn: {
      Footer() {
        const { toForgotPassword } = useAuthenticator();

        return (
          <View textAlign="center">
            {legalPPAcknowlegement}
            <Button
              fontWeight="strong"
              onClick={toForgotPassword}
              size="small"
              variation="link"
            >
              Forgot Password?
            </Button>
          </View>
        );
      },
    },
    SignUp: {
      FormFields() {
        return (
          <>
            <TextField
              name="username"
              type="username"
              label=""
              placeholder="Enter your username"
              value={uuidv4()}
              // disabled
              isRequired
              style={{ display: 'none' }}
            />
            <TextField
              name="email"
              type="email"
              label="Email"
              placeholder="Enter your Email"
              autoComplete="email"
              isRequired
            />
            <PasswordField
              name="password"
              label="Password"
              placeholder="Enter a Password"
              autoComplete="new-password"
              descriptiveText="Password must be at least 8 characters and contain uppercase and lowercase letters."
              isRequired
            />
            <TextField
              name="given_name"
              label="First Name"
              placeholder="Enter your First Name"
              autoComplete="given-name"
              isRequired
            />
            <TextField
              name="family_name"
              label="Last Name"
              placeholder="Enter your Last Name"
              autoComplete="family-name"
              isRequired
            />
            <PhoneNumberField
              name="phone_number"
              label="Phone (Optional)"
              defaultDialCode="+1"
              dialCodeName="country_code"
              placeholder="Enter your Phone Number"
              autoComplete="tel"
            />
            <View textAlign="center">
              {legalPPAcknowlegement}
            </View>
          </>
        );
      },
    },
  }), []);

  const formFields = useMemo(() => ({
    signIn: {
      username: {
        label: 'Email',
        placeholder: 'Enter your email',
        type: 'email',
        autocomplete: 'email',
        isRequired: true,
      },
      password: {
        label: 'Password',
        placeholder: 'Enter your password',
        autocomplete: 'current-password',
        isRequired: true,
      },
    },
  }), []);

  return (
    <Drawer
      open={authDrawerOpen}
      onClose={() => setAuthDrawerOpen(false)}
      placement="bottom"
      height="100%"
      className="auth-drawer"
      zIndex={1100}
      destroyOnClose
      width={480}
      mask
      maskClosable
      closable={false}
      maskStyle={{
        backgroundColor: 'var(--color-primary-dark2-70)',
        backdropFilter: 'blur(15px)',
      }}
    >
      <div
        className="authenticator-drawer-header"
        onClick={() => setAuthDrawerOpen(false)}
      >
        <CloseIcon style={{ fontSize: '150%', cursor: 'pointer' }} />
      </div>
      <Authenticator
        signUpAttributes={['email', 'given_name', 'family_name', 'phone_number']}
        socialProviders={['google']}
        components={components}
        hideSignUp={false}
        formFields={formFields}
      />
    </Drawer>
  );
};

export default memo(AuthDrawer);
